/**
 * Theme API Service
 * Fetches the per-domain website theme managed in the Backoffice
 * (Agent-Core-Service writes it; Agent-Amb-Service serves it).
 */

export const themeApi = {
  /**
   * Fetch the theme for a domain.
   * Returns the theme payload object; null when the API answered but no theme
   * is configured for the domain (caller should drop any cached theme); or
   * undefined on request failure (caller should keep whatever it has).
   * @param {Object} httpInstance - Axios instance
   * @param {String} domain - hostname to resolve the theme for
   * @returns {Promise<Object|null|undefined>}
   */
  async fetchTheme(httpInstance, domain) {
    try {
      const response = await httpInstance.post('/internal/theme', { domain })
      if (response.data.success) {
        return response.data.data || null
      }
      return undefined
    } catch (error) {
      console.error('[ThemeApi] Failed to fetch theme:', error.message)
      return undefined
    }
  }
}

export default themeApi
